import * as modalTypes from "../../../../constants/modalTypes";
import * as objectTypes from "../../../../constants/objectTypes";
import * as optionHelper from "../../../../helpers/optionHelper";
import * as propertyConstants from "../../../../constants/propertyConstants";
import * as tableConstants from "../../../../constants/tableConstants";
import * as translationHelper from "../../../../helpers/translationHelper";

import React, { Component } from "react";
import { User, createEmptyUser, generateUserData, generateUserHeadings } from "../../../../types/user";

import { ModalParams } from "../../../../types/modalParams";
import { ModalProperties } from "../../../../types/modalProperties";
import { TableContainer } from "../../../Table";
import { TableHeading } from "../../../../types/tableHeading";
import { generateUserGroupHeadings } from "../../../../types/userGroup";

type Props = {
    tableConstant: string;
    objectType: objectTypes.ObjectType;
    dataPrivileges: any;
    loading: boolean;
    buttonLoading: boolean;
    allList: Array<User>;
    activeList: Array<User>;
    columnOrder: Array<propertyConstants.Property>;
    columnVisibility: Record<propertyConstants.Property, boolean>;
    columnWidth: Record<propertyConstants.Property, number>;
    offset: number;
    page: number;
    rowCount: number;
    rowCountCustom: boolean;
    search: string | null;
    searchParams: Record<propertyConstants.Property, string>;
    showFilterRow: boolean;
    showGlobalSearch: boolean;
    sortingAsc: boolean;
    sortingCriterion: propertyConstants.Property | null;
    totalCount: number | null;
    custom: string | null;
};

export class MasterRedlikeUserTable extends Component<Props> {
    generateTableHeadings = (
        modalType: modalTypes.ModalType | null = null,
        objectType: objectTypes.ObjectType = this.props.objectType
    ): Array<TableHeading> => {
        const propertyList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_USERNAME,
            propertyConstants.PROPERTY_AUTOLOGIN
        ];
        const requiredList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_USERNAME,
            propertyConstants.PROPERTY_PASSWORD
        ];
        const alwaysVisibleList: Array<propertyConstants.Property> = [propertyConstants.PROPERTY_USERNAME];
        const editableList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_USERNAME,
            propertyConstants.PROPERTY_AUTOLOGIN
        ];
        let visibleList: Array<propertyConstants.Property> = [...propertyList];

        if (
            modalType === modalTypes.MODAL_MASTER_REDLIKE_USERS_ADD_PROPAGATE ||
            modalType === modalTypes.MODAL_MASTER_REDLIKE_USERS_EDIT_PROPAGATE
        ) {
            visibleList.splice(1, 0, propertyConstants.PROPERTY_PASSWORD);
            editableList.splice(1, 0, propertyConstants.PROPERTY_PASSWORD);
        }

        let orderList = [...visibleList];

        if (modalType === null) {
            orderList = optionHelper.handleTableHeadingOrder(visibleList, this.props.columnOrder);
            visibleList = optionHelper.handleTableHeadingVisibility(visibleList, this.props.columnVisibility);
        }

        return generateUserHeadings(
            objectType,
            [],
            [],
            orderList,
            visibleList,
            editableList,
            requiredList,
            alwaysVisibleList,
            this.props.columnWidth
        );
    };

    generateModalUserGroupHeadings = (): Array<TableHeading> => {
        return generateUserGroupHeadings(
            objectTypes.USER_GROUP,
            [propertyConstants.PROPERTY_NAME],
            [propertyConstants.PROPERTY_NAME],
            [],
            [],
            [],
            tableConstants.EMPTY_COLUMN_WIDTH
        );
    };

    generateAddModalParams = (): ModalParams => {
        return new ModalParams(
            modalTypes.PROPAGATE_MODAL,
            objectTypes.DEFAULT_MASTER_REDLIKE_USER_GROUP,
            "",
            createEmptyUser("", []),
            this.generateModalUserGroupHeadings(),
            undefined,
            this.generateModalUserGroupHeadings(),
            this.generateTableHeadings(
                modalTypes.MODAL_MASTER_REDLIKE_USERS_ADD_PROPAGATE,
                objectTypes.DEFAULT_MASTER_REDLIKE_USER_GROUP
            ),
            undefined,
            this.props.dataPrivileges,
            undefined,
            "simple-table"
        );
    };

    generateEditModalParams = (): ModalParams | null => {
        const activeData = generateUserData(this.props.activeList);

        if (activeData.length) {
            return new ModalParams(
                modalTypes.PROPAGATE_EDIT_MODAL,
                objectTypes.DEFAULT_MASTER_REDLIKE_USER_GROUP,
                "",
                activeData[0],
                this.generateModalUserGroupHeadings(),
                undefined,
                this.generateModalUserGroupHeadings(),
                this.generateTableHeadings(
                    modalTypes.MODAL_MASTER_REDLIKE_USERS_EDIT_PROPAGATE,
                    objectTypes.DEFAULT_MASTER_REDLIKE_USER_GROUP
                ),
                undefined,
                this.props.dataPrivileges,
                undefined,
                "simple-table"
            );
        }

        return null;
    };

    render(): JSX.Element {
        const modalProperties: ModalProperties = {
            addModalType: modalTypes.MODAL_MASTER_REDLIKE_USERS_ADD_PROPAGATE,
            addModalParams: this.generateAddModalParams(),
            editModalType: modalTypes.MODAL_MASTER_REDLIKE_USERS_EDIT_PROPAGATE,
            editModalParams: this.generateEditModalParams()
        };

        return (
            <div className="height-100">
                <TableContainer
                    className={"table-with-filter"}
                    tableConstant={this.props.tableConstant}
                    objectType={this.props.objectType}
                    dataPrivileges={this.props.dataPrivileges}
                    loading={this.props.loading}
                    buttonLoading={this.props.buttonLoading}
                    title={translationHelper.getTitleSectionTranslation(this.props.objectType, this.props.custom)}
                    titleClassName={"main-title"}
                    headings={this.generateTableHeadings()}
                    data={generateUserData(this.props.allList)}
                    activeData={this.props.activeList}
                    offset={this.props.offset}
                    page={this.props.page}
                    rowCount={this.props.rowCount}
                    rowCountCustom={this.props.rowCountCustom}
                    search={this.props.search}
                    searchParams={this.props.searchParams}
                    showFilterRow={this.props.showFilterRow}
                    showGlobalSearch={this.props.showGlobalSearch}
                    sortingAsc={this.props.sortingAsc}
                    sortingCriterion={this.props.sortingCriterion}
                    totalCount={this.props.totalCount}
                    modalProperties={modalProperties}
                />
            </div>
        );
    }
}
